<!-- 溯源码信息 预览溯源码 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="mr-24 mb-24 w200" type="text" v-model="storePrams.qrcode_number" placeholder="通过溯源码编码查询"></Input>
            <Select class="mr-24 mb-24 w200" v-model="storePrams.batch_id" clearable filterable placeholder="通过关联批次查询">
                <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
            </Select>
            <Select class="mr-24 mb-24 w200" v-model="storePrams.product_id" clearable filterable placeholder="通过关联产品查询">
                <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
            </Select>
            <Select class="mr-24 mb-24 w200" v-model="storePrams.status" clearable filterable placeholder="状态查询">
                <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <DatePicker class="mr-24 mb-24 width_15" type="daterange" v-model="dates" split-panels placement="bottom-start" placeholder="选择日期" separator=" 至 " @on-change="changeDate"></DatePicker>
            <Button class="theme-bc mb-24 mr-24" icon="ios-search" type="warning"  @click="goSearch">确认搜索</Button>
            <Button class="mb-24" icon="md-refresh" @click="goClear">清空条件</Button>
        </div>
        <div class="content">
            <div>
                <Button class="mb-24 mr-24" @click="goExport">批量导出</Button>
                <Button class="mb-24 mr-24" @click="goDrawer">导出记录</Button>
                <Button v-if="app_value" class="mb-24 mr-24" @click="goImportCode">导入码</Button>
                <Table :loading="loading" :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="product_name">
                        <div>
                            <div>商品:{{row.product ? row.product.product_name : ''}}</div>
                            <div>批次:{{row.batch ? row.batch.batch_name : ''}}</div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="agent_name">
                        <div>{{row.agent ? row.agent.agent_name : ''}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="qrcode_count">
                        <div class="flex-c">
                            <Tooltip v-if="row.qrcode_log.some(item => item.status == 2)" max-width="250" placement="top" theme="light" transfer>
                                <Icon class="cursor-p mr-12" type="md-help-circle" size="20" color="#FF4838"/>
                                <div slot="content"><p>生成失败原因......<br>可点击<span style="color: #2DC0F7;">刷新</span>,重新生成</p></div>
                            </Tooltip>
                            <span :style="row.qrcode_log.some(item => item.status == 2) ? '' : 'color: #53C41A;'">
                                {{row.qrcode_log.reduce((sum, item) => {
                                    if (item.status === 1) {
                                        return sum + item.qrcode_num;
                                    }
                                    return sum;
                                }, 0)}}
                            </span>
                            <span style="color: #53C41A;">/{{row.qrcode_count}}</span>
                            <Icon class="cursor-p ml-12" v-if="row.qrcode_log.some(item => item.status == 2)" type="md-refresh-circle" size="20" color="#2DC0F7" @click="goRefresh(row)"/>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div v-if="row.status == 1" style="color: #53C41A;"><Icon type="ios-checkmark-circle-outline" color="#53C41A"/>启用</div>
                        <div v-if="row.status == 2" style="color: #FF4838;"><Icon type="ios-close-circle-outline" color="#FF4838"/>未启用</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost label="small" @click="goManage(row)">预览</Button>
                            <Button type="primary" ghost label="small" @click="goModal(1, row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 预览（溯源码管理） -->
        <Drawer v-model="manageDrawer" title="溯源码管理" width="80">
            <div>
                <div class="flex-sb mb-12">
                    <div>
                        <Input class="mr-24 w200" type="text" v-model="pageQrcode.qrcode_number" placeholder="请输入溯源码编码查询"></Input>
                        <Select class="mr-24 w200" v-model="pageQrcode.status" clearable filterable placeholder="状态查询">
                            <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                        <DatePicker class="mr-24 w200" type="daterange" split-panels placement="bottom-start" placeholder="选择时间段" separator=" 至 "  @on-change="changeQrcodeDate"></DatePicker>
                    </div>
                    <Button class="theme-bc" icon="ios-search" type="warning" @click="goSearchQrcode">确认搜索</Button>
                </div>
                <Table :columns="columnQrcode" :data="dataQrcode" border>
                    <template slot-scope="{ row }" slot="qrcode_url">
                        <div class="flex-c" @click="goPreview(row)">
                            <img class="width_height_30 cursor-p mt-12 mb-12" src="../../assets/code_img.png">
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="product_name">
                        <div>
                            <div>产品:{{row.product ? row.product.product_name : ''}}</div>
                            <div>批次:{{row.batch ? row.batch.batch_name : ''}}</div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div v-if="row.status == 1" style="color: #53C41A;"><Icon type="ios-checkmark-circle-outline" color="#53C41A"/>启用</div>
                        <div v-if="row.status == 2" style="color: #FF4838;"><Icon type="ios-close-circle-outline" color="#FF4838"/>未启用</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="goModal(2, row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(2, row)">删除</Button>
                        </div>
                    </template>
                </Table>
                <div class="page">
                    <Page :current="pageQrcode.page" :page-size="pageQrcode.limit" :total="totalQrcode" show-elevator show-total @on-change="pageChangeQrcode"/>
                </div>
            </div>
        </Drawer>
        <!-- 导出记录 -->
        <Drawer v-model="infoDrawer" title="导出记录" width="80">
            <div>
                <Table :columns="columnExport" :data="dataExport" border>
                    <template slot-scope="{ row }" slot="batch_name">
                        <div>{{row.batch[0].batch_name}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="export_type_name">
                        <div>{{row.export_type_name}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div v-if="row.log.every(item => item.status == 1)" style="color: #53C41A;"><Icon type="ios-checkmark-circle-outline" color="#53C41A"/>导出成功</div>
                        <div v-else>
                            <div class="flex-c" v-if="row.log.some(item => item.status == 0)">
                                <img class="width_height_18" src="../../assets/loading.gif">
                                <span style="color: #FF761D;">正在导出</span>
                            </div>
                            <div v-if="row.log.some(item => item.status == 2)" style="color: #FF4838;"><Icon type="ios-close-circle-outline" color="#FF4838"/>导出失败</div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button v-if="row.log.every(item => item.status == 1)" type="primary" ghost label="small" @click="goDownload(row)">下载</Button>
                        </div>
                    </template>
                </Table>
                <div class="page">
                    <Page :current="pageExport.page" :page-size="pageExport.limit" :total="totalExport" show-elevator show-total @on-change="pageChangeExport"/>
                </div>
            </div>
        </Drawer>
        <!-- 预览 -->
        <Modal v-model="previewModal" title="预览" width="30" :mask-closable="false">
            <div class="flex-c flex-column">
                <div>查看编码为【{{itemData.qrcode_number}}】的溯源码效果</div>
                <div class="width_height_200">
                    <VueQr class="width_height_100" id="vueQr" :text="itemData.qrcode_url"></VueQr>
                </div>
                <div>扫码浏览模板</div>
                <div>支持任意扫码工具扫码查询</div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 批量导出 -->
        <Modal v-model="exportModal" title="批量导出" width="500" :mask-closable="false">
            <div>
                <Form :model="formExport" label-position="right" :label-width="100">
                    <FormItem label="选择批次：">
                        <Select v-model="formExport.batch_id" clearable filterable placeholder="请选择批次">
                            <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="选择导入项：">
                        <CheckboxGroup v-model="itemData.exportValue">
                            <Checkbox label="关联批次" border></Checkbox>
                            <Checkbox label="关联产品" border></Checkbox>
                        </CheckboxGroup>
                    </FormItem>
                    <FormItem label="选择格式：">
                        <Select class="w200" v-model="formExport.export_type" clearable filterable placeholder="请选择格式">
                            <Option v-for="item in exportTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                        <Tooltip max-width="250" placement="bottom" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content">
                                <p>导出印刷重要说明提示:</p>
                                <p>1、当溯源码编码为纯数字,且超15位时,用EXCLE打开,会以科学计数法显示,导致编码出错。如果存在该情况,建议导出为TXT格式。</p>
                                <p>2、正式批量印刷前,请先印几张用于测试,以免错误。</p>
                                <p>3、导出成功,为了数据安全,只做临时存储请点击<span class="theme-color">“导出记录”</span>下载数据包到本地点击下载数据包到本地。</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelExportModal">取消</Button>
                <Button class="theme-bc" type="warning" :disabled="!isClickable" @click="submitExportModal">确定</Button>
            </div>
        </Modal>
        <!-- 溯源码编辑 -->
        <Modal v-model="modals" :title="modalTitle" :width="modalWidth" :mask-closable="false">
            <div>
                <Form :model="formData" label-position="right" :label-width="150">
                    <FormItem label="选择关联批次：">
                        <Select class="w200" v-model="formData.batch_id" clearable filterable placeholder="请选择关联批次">
                            <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                        </Select>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>选择批次,没有请先在【批次管理】中【新增批次】</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="选择关联产品：">
                        <Select class="w200" v-model="formData.product_id" clearable filterable placeholder="请选择关联产品">
                            <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
                        </Select>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>选择关联的产品,生成后可批量修改更换</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="选择所属代理商：">
                        <Select class="w200" v-model="formData.agent_id" clearable filterable placeholder="请选择所属代理商">
                            <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.agent_name }}</Option>
                        </Select>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>选择默认所属的代理商，不选则暂时为空</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="生产时间：">
                        <DatePicker class="w200" :value="formData.productive_time" type="date" placeholder="点击选择时间" @on-change="changeProductiveTime"></DatePicker>
                    </FormItem>
                    <FormItem label="过期时间：">
                        <DatePicker class="w200" :value="formData.expiration_date" type="date" placeholder="点击选择时间" @on-change="changeExpirationDate" ></DatePicker>
                    </FormItem>
                    <FormItem label="是否启用：">
                        <i-switch v-model="formData.status" size="large" true-color="#FF761D" :true-value="1" :false-value="2">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal">确定</Button>
            </div>
        </Modal>
        <!-- 导入码 -->
        <Modal v-model="importCodeModal" title="导入码" width="500" :mask-closable="false">
            <div>
                <Form :model="formImportCode" label-position="right" :label-width="100">
                    <FormItem label="选择批次：">
                        <Select v-model="formImportCode.batch_id" clearable filterable placeholder="请选择批次">
                            <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="选择产品：">
                        <Select v-model="formImportCode.product_id" clearable filterable placeholder="请选择产品">
                            <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="上传文件：">
                        <div style="display: flex;">
                            <Upload
                            ref="upload"
                            :show-upload-list="false"
                            :format="['xlsx']"
                            :max-size="5120"
                            :on-exceeded-size="exceededSize"
                            :on-format-error="handleFormatError"
                            :on-success="keySuccess"
                            :on-progress="handleProgress"
                            :headers="headers"
                            :action="uploadImg"
                            >
                                <Button>{{formImportCode.file ? '已成功上传' : '点击上传'}}</Button>
                            </Upload>
                            <Tooltip max-width="250" placement="right" theme="light">
                                <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                                <div slot="content"><p>只支持xlsx文件，数据较多需耐心等待处理</p></div>
                            </Tooltip>
                        </div>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelImportCodeModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitImportCodeModal">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { 
    qrcode_count_list, 
    qrcode_count_delete, 
    qrcode_count_refresh, 
    qrcode_count_edit, 
    qrcode_count_info, 
    qrcode_list,
    qrcode_info, 
    qrcode_edit,
    qrcode_delete, 
    export_list, 
    export_qrcode, 
    other_special_import,
} from '@/api/index';
import { product_select, batch_select, agent_select } from '@/api/select';
import VueQr from 'vue-qr';
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
export default {
    components: { VueQr },
    props: {
        codeData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            uploadImg: config.apiUrl + "/api/other/upload",
            headers: { "hlzw-suyuan-token": getCookies("pcToken") },
            dates: "",
            storePrams: {
                page: 1,
                limit: 10,
                product_id: "",
                batch_id: "",
                status: "",
                start_date: "",
                end_date: "",
                qrcode_number: "",
            },
            total: 0,
            columnsTable: [
                { type: 'selection', width: 60, align: 'center' },
                { title: "ID", key: "id", align: "center" },
                { title: "关联信息", slot: "product_name", align: "center" },
                { title: "代理商", slot: "agent_name", align: "center" },
                { title: "生成时间", key: "created_at", align: "center" },
                { title: "生成状态", slot: "qrcode_count", align: "center", width: "200px" },
                { title: "码状态", slot: "status", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "300px" },
            ],
            dataTable: [],
            itemData: { 
                count_id: "",
                qrcode_url: "",
                qrcode_number: '',
                prefix1: "",
                prefix2: "",
                prefix3: "",
                prefix4: "",
                id: "",
                exportValue: [],
            },
            formData: {
                batch_id: "",
                product_id: "",
                agent_id: "",
                status: 2,
                qrcode_count: "",
                qrcode_length: "",
                qrcode_prefix: "",
                qrcode_type: "",
                productive_time: "",
                expiration_date: "",
                type: "",
            },
            batchList: [],
            productList: [],
            agentList: [],
            statusList: [
                { id: 1, name: "开启" },
                { id: 2, name: "关闭" },
            ],
            previewModal: false,
            exportModal: false,
            modals: false,
            modalTitle: '',
            modalID: '',
            modalWidth: "",
            manageDrawer: false,
            infoDrawer: false,
            pageQrcode: {
                start_date: "",
                end_date: "",
                qrcode_number: "",
                limit: 10,
                page: 1,
                status: "",
                count_id: "",
            },
            totalQrcode: 0,
            columnQrcode: [
                { type: 'selection', width: 60, align: 'center' },
                { title: "ID", key: "id", align: "center" },
                { title: "溯源码编码", key: "qrcode_number", align: "center" },
                { title: "溯源码", slot: "qrcode_url", align: "center" },
                { title: "关键信息", slot: "product_name", align: "center" },
                { title: "码状态", slot: "status", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataQrcode: [],
            formExport: {
                batch_id: "",
                is_product: 0,
                is_batch: 0,
                export_type: "",
            },
            exportTypeList: [
                { id: 1, name: "Excel电子文档格式" },
                { id: 2, name: "TXT文本格式" },
            ],
            pageExport: {
                limit: 10,
                page: 1,
            },
            totalExport: 0,
            columnExport: [
                { title: "导出批次", slot: "batch_name", align: "center" },
                { title: "导出项", key: "export_action", align: "center" },
                { title: "选择格式", slot: "export_type_name", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "导出时间", key: "created_at", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "100px" },
            ],
            dataExport: [],
            isClickable: true,
            importCodeModal: false,
            formImportCode: {
                batch_id: "",
                product_id: "",
                file: "",
            },
            app_ids: '',
            app_value: false,
            loading: false,
        };
    },
    created(){
        this.app_ids = localStorage.getItem('app_ids');
        this.app_value = this.app_ids.includes(6); // 检查是否包含6
    },
    mounted() {
        this.getList();
        this.getProductSelect();
        this.getBatchSelect();
        this.getagentSelect();
    },
    watch: {
        // 批次管理-预览溯源码
        codeData(newVal, oldVal) {
            this.loading = true;
            this.storePrams.batch_id = newVal.id;
            qrcode_count_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
                this.loading = false;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        }
    },
    methods: {
        getList() {
            qrcode_count_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
                // 删除后，page--
                if(!res.data.data.length && this.storePrams.page != 1){
                    this.storePrams.page --;
                    this.getList();
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getQrcodeList(){
            qrcode_list(this.pageQrcode).then((res) => {
                this.dataQrcode = res.data.data;
                this.totalQrcode = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getExportList(){
            export_list(this.pageExport).then((res) => {
                this.dataExport = res.data.data;
                this.totalExport = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageChangeQrcode(index) {
            this.pageQrcode.page = index;
            this.getQrcodeList();
        },
        pageChangeExport(index) {
            this.pageExport.page = index;
            this.getExportList();
        },
        goSearch() {
            this.getList();
        },
        goSearchQrcode(){
            this.getQrcodeList();
        },
        goClear(){
            this.storePrams.page = 1;
            this.storePrams.limit = 10;
            this.storePrams.product_id = "";
            this.storePrams.batch_id = "";
            this.storePrams.status = "";
            this.storePrams.start_date = "";
            this.storePrams.end_date = "";
            this.storePrams.qrcode_number = "";
            this.dates = "";
        },
        goRefresh(row){
            let that = this;
            this.$Modal.confirm({
                title: '提示',
                content: '是否确认重新生成？',
                onOk: () => {
                    qrcode_count_refresh({id: row.id}).then((res) => {
                        that.getList();
                        this.$Message.success(res.msg);
                    })
                    .catch((err) => {
                        this.$Message.error(err.msg);
                    });
                },
                onCancel: () => {
                }
            });
        },
        // 下拉
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getagentSelect(){
            agent_select().then((res) => {
                this.agentList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        changeDate(e){
            if(e[0]){
                this.storePrams.start_date = e[0];
                this.storePrams.end_date = e[1];
            }else {
                this.storePrams.start_date = '';
                this.storePrams.end_date = '';
            }
        },
        changeQrcodeDate(e){
            if(e[0]){
                this.pageQrcode.start_date = e[0];
                this.pageQrcode.end_date = e[1];
            }else {
                this.pageQrcode.start_date = '';
                this.pageQrcode.end_date = '';
            }
        },
        changeProductiveTime(e){
            if(e){
                this.formData.productive_time = e;
            }else {
                this.formData.productive_time = '';
            }
        },
        changeExpirationDate(e){
            if(e){
                this.formData.expiration_date = e;
            }else {
                this.formData.expiration_date = '';
            }
        },
        goDel(index, row){
            let that = this;
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    if(index == 1){
                        qrcode_count_delete({ id:row.id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 2){
                        qrcode_delete({ id:row.id }).then(res=>{
                            that.getQrcodeList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }
                },
                onCancel: () => {
                }
            }); 
        },
        goPreview(row){
            this.itemData.qrcode_number = row.qrcode_number;
            if(row.qrcode_url){
                this.itemData.qrcode_url = row.qrcode_url;
            }
            this.previewModal = true;
        },
        goExport(){
            this.formExport.batch_id = '';
            this.formExport.is_product = 0;
            this.formExport.is_batch = 0;
            this.formExport.export_type = '';
            this.exportModal = true;
        },
        goImportCode(){
            this.formImportCode.batch_id = '';
            this.formImportCode.product_id = '';
            this.formImportCode.file = ''
            this.importCodeModal = true;
        },
        goModal(index, row){
            this.modalID = index;
            this.modalTitle = '溯源码编辑';
            this.modalWidth = 600;
            if(index == 1){
                qrcode_count_info({ id:row.id }).then(res=>{
                    this.formData.batch_id = res.data.batch_id;
                    this.formData.product_id = res.data.product_id;
                    this.formData.agent_id = res.data.agent_id;
                    this.formData.status = res.data.status;
                    this.formData.qrcode_count = res.data.qrcode_count;
                    this.formData.qrcode_length = res.data.qrcode_length;
                    this.formData.qrcode_prefix = res.data.qrcode_prefix;
                    this.formData.qrcode_type = res.data.qrcode_type;
                    this.formData.productive_time = res.data.productive_time;
                    this.formData.expiration_date = res.data.expiration_date;
                    this.formData.type = res.data.type;
                    this.itemData.count_id = res.data.id;
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }else if(index == 2){
                qrcode_info({ id:row.id }).then(res=>{
                    this.formData.batch_id = res.data.batch_id;
                    this.formData.product_id = res.data.product_id;
                    this.formData.agent_id = res.data.agent_id;
                    this.formData.status = res.data.status;
                    this.formData.productive_time = res.data.productive_time;
                    this.formData.expiration_date = res.data.expiration_date;
                    this.itemData.id = res.data.id;
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }
            setTimeout(() => {
                this.modals = true;
            }, 500);
        },
        cancelExportModal(){
            this.exportModal = false;
        },
        submitExportModal(){
            if (this.isClickable) {
                this.isClickable = false;
                setTimeout(() => {
                    this.isClickable = true;
                }, 1000);
                this.itemData.exportValue.forEach(item => {
                    if(item == "关联批次"){
                        this.formExport.is_batch = 1;
                    }else if(item == "关联产品"){
                        this.formExport.is_product = 1;
                    }
                });
                if(!this.formExport.batch_id){
                    this.$Message.error('请选择批次');
                    return
                }
                if(!this.formExport.is_batch && !this.formExport.is_product){
                    this.$Message.error('请选择导入项');
                    return
                }
                if(!this.formExport.export_type){
                    this.$Message.error('请选择格式');
                    return
                }
                export_qrcode(this.formExport).then(res=>{
                    this.getList();
                    this.exportModal = false;
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }
        },
        cancelImportCodeModal(){
            this.importCodeModal = false;
        },
        submitImportCodeModal(){
            if(!this.formImportCode.batch_id && !this.formImportCode.product_id){
                this.$Message.error('请选择批次/产品');
                return
            }
            if(!this.formImportCode.file){
                this.$Message.error('请上传文件');
                return
            }
            other_special_import(this.formImportCode).then(res=>{
                this.getList();
                this.importCodeModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        cancelModal(){
            this.modals = false;
        },
        submitModal(){
            if(this.modalID == 1){
                let data = {
                    batch_id: this.formData.batch_id,
                    product_id: this.formData.product_id,
                    agent_id: this.formData.agent_id,
                    status: this.formData.status,
                    productive_time: this.formData.productive_time,
                    expiration_date: this.formData.expiration_date,
                    id: this.itemData.count_id,
                }
                qrcode_count_edit(data).then(res=>{
                    this.getList();
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }else if(this.modalID == 2){
                let data = {
                    id: this.itemData.id,
                    batch_id: this.formData.batch_id,
                    product_id: this.formData.product_id,
                    agent_id: this.formData.agent_id,
                    status: this.formData.status,
                    productive_time: this.formData.productive_time,
                    expiration_date: this.formData.expiration_date,
                }
                qrcode_edit(data).then(res=>{
                    this.getQrcodeList();
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }
            this.modals = false;
        },
        goManage(row){
            this.pageQrcode.count_id = row.id;
            this.pageQrcode.page = 1;
            this.pageQrcode.limit = 10;
            this.pageQrcode.start_date = '';
            this.pageQrcode.end_date = '';
            this.pageQrcode.qrcode_number = '';
            this.pageQrcode.status = '';
            this.getQrcodeList();
            setTimeout(() => {
                this.manageDrawer = true;
            }, 300);
        },
        goDrawer(){
            this.getExportList();
            setTimeout(() => {
                this.infoDrawer = true;
            }, 300);
        },
        goDownload(row){
            window.open(row.show_path);
        },
        // 文件上传时
        handleProgress(){
            this.$Message.loading({
                content: '上传中...',
                duration: 0
            }) 
        },
        exceededSize(e) {
            this.$Message.warning("文件大小限制在5MB以内");
        },
        // 文件上传类型错误
        handleFormatError(){                
            this.$Message.destroy();
            this.$Message.warning("请上传xlsx格式");
        },
        keySuccess(e){
            this.formImportCode.file = e.data.url;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.width_height_100 {
    width: 100%;
    height: 100%;
}
.width_height_30 {
    width: 30px;
    height: 30px;
}
::v-deep .ivu-checkbox-wrapper-checked.ivu-checkbox-border {
    background: #53C41A;
    border-radius: 5px;
    font-size: 14px;
    color: #fff;
    border-color: #53C41A;
}
::v-deep .ivu-checkbox {
    display: none;
}
::v-deep .ivu-checkbox.ivu-checkbox-checked {
    display: none;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    box-shadow: -1px 0 0 0 #53C41A;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.width_height_18 {
    width: 18px;
    height: 18px;
}
.width_height_200 {
    width: 200px;
    height: 200px;
    border: 1px solid #9fa5bb;
}
.width_15 {
    width: 15vw;
}
.flex-column {
    flex-direction: column !important;
}
</style>